/**
 * @desc 保存
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(body: defs.srm.SupplierBankAccountRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/srm/supplierBankAccount/save`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
